
























































import Vue from 'vue'
import { ValidationProvider } from 'vee-validate'

export type DataType = {
  currentYear: number
}

export default Vue.extend({
  components: {
    ValidationProvider,
  },
  props: {
    cardNumber: {
      type: String,
      required: true,
    },
    expireMonth: {
      type: String,
      required: true,
    },
    expireYear: {
      type: String,
      required: true,
    },
    name: {
      type: String,
    },
    cvv: {
      type: String,
      required: true,
    },
  },
  data(): DataType {
    return {
      currentYear: new Date().getFullYear(),
    }
  },
  computed: {
    inputCardNumber: {
      get(): string {
        return this.cardNumber
      },
      set(value: string) {
        this.$emit('update:cardNumber', this.numericValidate(value))
      },
    },
    inputExpireYear: {
      get(): string {
        return this.expireYear
      },
      set(value: string) {
        this.$emit('update:expireYear', value)
      },
    },
    inputExpireMonth: {
      get(): string {
        return this.expireMonth
      },
      set(value: string) {
        this.$emit('update:expireMonth', value)
      },
    },
    inputName: {
      get(): string {
        return this.name
      },
      set(value: string) {
        this.$emit('update:name', this.alphaValidate(value))
      },
    },
    inputCvv: {
      get(): string {
        return this.cvv
      },
      set(value: string) {
        this.$emit('update:cvv', this.numericValidate(value))
      },
    },
  },
  methods: {
    numericValidate(value: string): string {
      return value.replace(/\D/g, '')
    },
    alphaValidate(value: string): string {
      return value.replace(/[^A-Za-z0-9 ,\-/.]/g, '')
    },
    validateCardNumber(value: string) {
      if (!value) {
        return 'カード番号は必須です'
      }

      if (!/^[0-9]+$/i.test(value)) {
        return 'カード番号は数字のみです'
      }

      return true
    },
    validateCardName(value: string) {
      if (!/^[^A-Za-z0-9 ,\-/.]+$/i.test(value)) {
        return '名義人はアルファベット、数字、記号(,-.)のみです'
      }

      return true
    },
    validateCvv(value: string) {
      if (!value) {
        return 'セキュリティコードは必須です'
      }

      if (!/^[0-9]+$/i.test(value)) {
        return 'セキュリティコードは数字のみです'
      }

      return true
    },
  },
})
